import Touchable from '@components/Touchable'
import { getTop5collections } from '@helpers/nftCollectionsHelper'
import useConfig from '@plug-core/hooks/useConfig'
import { logger } from '@plug-core/logger'
import {
  Avatar,
  Chip,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { HiQuestionMarkCircle } from 'react-icons/hi2'

interface Collection {
  name: string
  canisterId: string
  icpVolume: number
}

export enum TimeFrames {
  PastDay = 'past24h',
  AllTime = 'allTime',
}

const USERGEEKS_URL = 'https://t5t44-naaaa-aaaah-qcutq-cai.raw.ic0.app/collection'

const NFTsTab: FC = () => {
  const [selectedTimeFrame, setSelectedTimeFrame] = useState<TimeFrames>(TimeFrames.PastDay)
  const [top5nftCollections, setTop5NftCollections] = useState<Collection[]>([])
  const { nfts, tokenPricesWithChange } = useConfig()
  const { t } = useTranslation()

  useEffect(() => {
    fetchNFTs()
  }, [selectedTimeFrame])

  const fetchNFTs = async () => {
    try {
      const top5CollectionsByVolume = await getTop5collections(
        selectedTimeFrame,
        tokenPricesWithChange
      )
      setTop5NftCollections(top5CollectionsByVolume)
    } catch (error) {
      logger.error('Failed to load NFTs', { originalError: error })
    }
  }

  return (
    <Stack spacing={1}>
      <Stack justifyContent="space-between" alignItems="center" direction="row" mb={1}>
        <Stack direction="row" spacing={1}>
          {Object.values(TimeFrames).map((section) => (
            <Touchable key={section} onClick={() => setSelectedTimeFrame(section)}>
              <Chip
                label={t(`discover.tabs.nfts.${section}`)}
                color={section === selectedTimeFrame ? 'primary' : 'secondary'}
              />
            </Touchable>
          ))}
        </Stack>
        <Typography>{t('discover.tabs.nfts.volume')}</Typography>
      </Stack>
      {top5nftCollections.map((collection, index) => {
        const dabCollection = nfts.find((c) => c.principal_id.toString() === collection.canisterId)

        return (
          <Touchable
            onClick={() => window.open(`${USERGEEKS_URL}/${collection.canisterId}`, '_blank')}
            key={collection.canisterId}
          >
            <ListItem>
              <ListItemAvatar>
                <Stack direction="row" alignItems="center" spacing={1.5} mr={2}>
                  <Typography>{index + 1}</Typography>
                  <Avatar src={dabCollection?.icon}>
                    {!dabCollection?.icon && <HiQuestionMarkCircle />}
                  </Avatar>
                </Stack>
              </ListItemAvatar>
              <ListItemText primary={collection.name} />
              <ListItemText
                primary={
                  selectedTimeFrame === TimeFrames.PastDay
                    ? `${collection.icpVolume.toFixed(2)}`
                    : (collection.icpVolume / 1000).toFixed(3) + ' K'
                }
                secondary={'ICP'}
                primaryTypographyProps={{ textAlign: 'right' }}
                secondaryTypographyProps={{ textAlign: 'right' }}
              />
            </ListItem>
          </Touchable>
        )
      })}
    </Stack>
  )
}

export default NFTsTab
